import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const MainBox = styled(Box)`
  margin-top: 20px;
`

export const HeaderContainer = styled(Box)`
  display: grid;
  grid-template-columns: 25% 30% 30%;
  margin-bottom: 8px;
  margin-left: 20px;
  gap: 16px;
`

export const BodyContainer = styled(Box)`
  display: grid;
  grid-template-columns: 25% 30% 30%;
  align-items: center;
  background-color: #f9f9f9;
  height: 60px;
  margin-top: 3px;
  padding-left: 20px;
  gap: 16px;
`

export const HeaderParagraph = styled(Box)`
  font-weight: 600;
  font-size: 16px;
`

export const typographyNameStyle = {
  marginTop: '5px',
  fontSize: '1.1rem',
  fontWeight: 600,
  width: '90%',
}

export const textFieldStyle = {
  '& .MuiInputBase-root': {
    height: '35px',
    width: '55px',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit',
    },
  },
}

export const editAbleRowBoxWrapper = {
  display: 'flex',
  flexDirection: 'row',
  marginTop: '5px',
  justifyContent: 'space-around',
  alignItems: 'flex-start',
  gap: '20px',
}

export const rightHelperTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'red',
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
    width: '55px',
    textAlign: 'left',
    lineHeight: 1,
    height: '10px',
    margin: 0,
    marginTop: '3px',
    padding: 0,
  },
}

export const leftHelperTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'red',
    fontSize: '0.75rem',
    width: '55px',
    textAlign: 'left',
    lineHeight: 1,
    height: '10px',
    margin: 0,
    marginTop: '3px',
    padding: 0,
    whiteSpace: 'nowrap',
  },
}

export const controllerWithWrapperBox = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '10px',
}

export const warningColor = {
  '& .MuiFormHelperText-root': {
    color: 'orange',
    fontSize: '0.75rem',
    width: '55px',
    textAlign: 'left',
    lineHeight: 1,
    height: '10px',
    margin: 0,
    marginTop: '3px',
    padding: 0,
    whiteSpace: 'nowrap',
  },
}
